import React from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';

const ButtonBasic = ({
    tooltipText,
    children,
    isLoading,
    onClick,
    iconStart,
    iconEnd,
    variant='contained',
    color="secondary",
    textButton = '',
    isDisabled,
    ...otherProps
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    
    return (
        <React.Fragment>
            {tooltipText ? (
                <Tooltip title={tooltipText}>
                    <LoadingButton
                        loading={isLoading}
                        startIcon={iconStart}
                        endIcon={iconEnd}
                        onClick={onClick}
                        variant={variant}
                        color={color}
                        loadingPosition={iconStart ? "start": iconEnd ? 'end' : 'center' }
                        disabled={isDisabled}
                        {...otherProps}
                    >
                        {textButton}
                    </LoadingButton>
                </Tooltip>
            ):(
                <LoadingButton
                    loading={isLoading}
                    startIcon={iconStart}
                    endIcon={iconEnd}
                    onClick={onClick}
                    variant={variant}
                    color={color}
                    loadingPosition={iconStart ? "start": iconEnd ? 'end' : 'center' }
                    disabled={isDisabled}
                    {...otherProps}
                >
                    {textButton}
                </LoadingButton>
            )}
        </React.Fragment>
    )
}


export default ButtonBasic